<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            v-model="shabuCondition.show"
            @hidden="closeConditionShabu()" 
            hide-footer
        >
        <template slot="modal-title">
            <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
                <div class="col-12">
                <h3 class="mb-0">เงื่อนไขการใช้ E-Voucher</h3>
                </div>
            </div>
            </div>
        </template>
        <card shadow type="secondary" class="m--4">
            <h4>เงื่อนไขและข้อกำหนดการใช้ E-Voucher</h4>
            <div v-for="(item , index) in conditionShabu.condition" :key="'C'+index" class="pl-3">
                <h5 v-html="item"></h5> 
            </div>
            <h4>ข้อห้ามในการใช้ E-Voucher</h4>
            <div v-for="(item , index) in conditionShabu.interdict" :key="'I'+index" class="pl-3">
                <h5>{{item}}</h5> 
            </div>
            <h4>กรณีความเสี่ยงและบัตรสูญหาย</h4>
            <h5 class="pl-3">• บริษัทฯ ขอสงวนสิทธิ์ในการยกเลิกบัตร E-Voucher หากพบว่า E-Voucher ที่นำมาใช้ได้รับมาจากวิธีการฉ้อฉลหรือเหตุผิดปกติวิสัย</h5> 
            <h4>ค่าตอบแทน</h4>
            <div v-for="(item , index) in conditionShabu.compensation" :key="'CP'+index" class="pl-3">
                <h5>{{item}}</h5> 
            </div>
            <div class="mt-4 w-100 text-center">
                <div class="pb-4">
                    <b-form-checkbox
                        v-model="shabuCondition.status"
                        :value="true"
                        :unchecked-value="false"
                    >
                        ฉันยอมรับ <u>นโยบายความเป็นส่วนตัว</u> และ <u>ข้อกำหนดและเงื่อนไข</u>
                    </b-form-checkbox>
                </div>
                <b-button variant="secondary" @click="closeConditionShabu()">ปิด</b-button>
                <b-button type="submit" variant="success" :disabled="!shabuCondition.status" @click="$emit('confirmConditionShabu')">ยอมรับ</b-button>
            </div>
        </card>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ModalConditionShabu" ,
    props: {
        shabuCondition: Object,
    },
    methods: {
        closeConditionShabu(){
            this.shabuCondition.show = false
        },
    },
    computed: {
        conditionShabu() {
            return {
                condition:[
                    '1. E-Voucher มีอายุการใช้งานตั้งแต่วันที่ 16 สิงหาคม 2564 - 31 ธันวาคม 2564 เท่านั้น',
                    '2. ติดต่อซื้อ E-Voucher ได้จาก SHIPPOP SHOP (เฉพาะสาขาที่ระบุ)',
                    '3. E-Voucher นี้ มีมูลค่า 500 บาทสามารถใช้แทนเงินสดเพื่อชำระอาหารและเครื่องดื่ม ที่<span class="text-red">หน้าร้านและสั่งผ่าน Line@ : @Shabubootueng เท่านั้น</span> ไม่รวมค่าจัดส่ง ที่ร้านชาบูบู๊ตึ๊งทุกสาขาในประเทศไทยโดยไม่สามารถนำไปใช้เพื่อชำระค่าอาหารและเครื่องดื่มผ่านแอพพลิเคชันอื่นๆได้นอกจาก Line@ ชาบูบู๊ตึ๊ง',
                    '4. E-Voucher เปรียบเสมือนเงินสด กรณีบัตรสูญหายไม่สามารถทำการอายัดออกใหม่ หรือชดเชยมูลค่าคงเหลือได้',
                    '5. E-Voucher ไม่สามารถนำมาแลกเปลี่ยนหรือทอนเป็นเงินสดได้',
                    '6. ยอดการใช้จ่ายผ่าน E-Voucher จะถูกหักออกจากมูลค่าคงเหลือใน E-Voucher โดยเจ้าหน้าที่แจ้งให้ผู้ถือบัตรรับทราบ ณ จุดที่มีการชำระค่าใช้จ่ายดังกล่าว โดย E-Voucher สามารถใช้ได้ 1 ครั้ง ไม่สามารถใช้ซ้ำได้ ในกรณีที่ยอดการใช้จ่ายเกินมูลค่า E-Voucher สามารถชำระส่วนต่างเพิ่มเติมด้วยเงินสดหรือบัตรเครดิต',
                    '7. E-Voucher ไม่สามารถใช้ร่วมกับโปรแกรมส่งเสริมการขายอื่น ๆ ได้ และมูลค่าคงเหลือในบัตรไม่สามารถโอนย้ายให้กับ Voucher ใบอื่นได้',
                    '8. เมื่อมีการนำ E-Voucher มาใช้ จะไม่สามารถสะสมแต้มได้',
                    '9. เงื่อนไขเป็นไปตามที่บริษัทฯกำหนด'
                ],
                interdict: [
                    '• E-Voucher นี้ไม่สามารถนำไปใช้เพื่อชำระค่าอาหารและเครื่องดื่มผ่านแอพพลิเคชันอื่นๆ ได้นอกจาก Line@ ชาบูบู๊ตึ๊ง'
                ],
                compensation: [
                    '• จะได้รับค่าตอบแทน 10 บาท ต่อการขาย E-voucher 1 ใบ รวมภาษีมูลค่าเพิ่มแล้ว และมีการหักภาษีหัก ณ ที่จ่าย สำหรับค่าตอบแทนที่มีการโอนชำระให้',
                    '• ในวันสุดท้ายของแต่ละเดือนสำหรับบริการที่ให้ในแต่ละเดือน จะชำระค่าบริการภายในสี่สิบห้า (45) วันหลังจากสรุปยอดโดยค่าตอบแทนดังกล่าวจะชำระให้ต่อเมื่อมียอดตั้งแต่ 500 บาทขึ้นไป หากยังไม่ครบ 500 บาท จะถูกรวบรวมจนกว่าจะครบและชำระเงินให้ในรอบของเดือนถัดไปที่ยอดครบตามที่กำหนดเท่านั้น และจะโอนให้ทางบัญชีที่แจ้งไว้กับทางชิปป๊อป'
                ]
            }
        }
    }
}
</script>